export default __webpack_public_path__ + "static/media/servicosPerguntas.01236889.png";